import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import styled from 'styled-components';
import tw from 'twin.macro';
import { IProtectionPlan, ProtectionPlanEnum } from '../../../../__generated__/graphql';
import {
  formatDeclinedLiabilityPercent,
  resolveDeclinedProtectionOutOfPocketPercent,
} from '../../../utils/declinedProtectionLiability';

const DetailsCard = styled.div`
  ${tw`mt-4 rounded-lg bg-bg-secondary p-4`}
`;

const DetailsTitle = styled.p`
  ${tw`text-sm font-semibold text-text-primary mb-2`}
`;

const LiabilityLine = styled.p`
  ${tw`text-sm text-text-primary mb-2`}
`;

const MarkdownBody = styled.div`
  ${tw`text-sm text-text-primary prose prose-sm max-w-none`}
`;

function coverageMarkdownSource(plan: IProtectionPlan): string {
  const policy = plan.policyDetails?.trim();
  if (policy) return policy;
  return plan.description?.trim() ?? '';
}

export function ProtectionPlanCoverageDetails({ plan }: { plan: IProtectionPlan }) {
  const isDeclined = plan.plan === ProtectionPlanEnum.Declined;
  const liability = isDeclined
    ? formatDeclinedLiabilityPercent(
        resolveDeclinedProtectionOutOfPocketPercent({
          percent: (plan as any).declinedProtectionOutOfPocketPercent,
          legacyPolicy: (plan as any).declinedProtectionOutOfPocketAmt,
        }),
      )
    : null;
  const markdown = coverageMarkdownSource(plan);

  if (!isDeclined && !markdown) {
    return null;
  }

  return (
    <DetailsCard>
      <DetailsTitle>Coverage details</DetailsTitle>
      {liability && <LiabilityLine>Maximum liability: {liability}.</LiabilityLine>}
      {markdown ? (
        <MarkdownBody>
          <ReactMarkdown rehypePlugins={[rehypeRaw]}>{markdown}</ReactMarkdown>
        </MarkdownBody>
      ) : null}
    </DetailsCard>
  );
}
